export default __webpack_public_path__ + "static/media/Search.f053036e.svg";